
// Polyfills for AWS Amplify compatibility with browser environments
(window as any).global = window;
(window as any).process = {
  env: { DEBUG: undefined },
};
